'use client';

import { SquareImage } from '@/components/SquareImage';
import { relativePath } from '@/functions/redirectToRelativePath';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { InfoTable } from './InfoTable';

type Props = {
  imEvent: ImEventDto;
  rank: number;
  customerSetting: CustomerSetting;
};

export const RankingCard: React.FC<Props> = ({
  imEvent,
  rank,
  customerSetting
}) => {
  const theme = useTheme();

  return (
    <Box>
      <ButtonBase
        component="a"
        href={relativePath(
          `/events/${imEvent.publicCode}`,
          customerSetting.domain
        )}
        sx={{ width: '100%', py: 1 }}
      >
        <Card elevation={0} sx={{ width: '100%', borderRadius: 0 }}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 4 }}>
              <SquareImage
                customerSetting={customerSetting}
                imageUrl={imEvent.imageUrl}
                imageAlt={imEvent.title}
                badge={
                  <Box
                    sx={{
                      height: 25,
                      width: 25,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      fontWeight: theme.typography.fontWeightBold
                    }}
                  >
                    {rank}
                  </Box>
                }
              />
            </Grid>
            <Grid size={{ xs: 8 }}>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  p: { xs: 0, sm: 1, md: 0 }
                }}
              >
                <Typography
                  variant="body2"
                  component="h3"
                  fontWeight={theme.typography.fontWeightBold}
                  sx={{
                    fontSize: {
                      xs: theme.typography.body2.fontSize,
                      sm: theme.typography.h6.fontSize,
                      md: theme.typography.body2.fontSize
                    }
                  }}
                >
                  {imEvent.title}
                </Typography>
                <Box>
                  <InfoTable imEvent={imEvent} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </ButtonBase>
    </Box>
  );
};
